<span [ngClass]="_containerClass">
  <ng-content *ngIf="buttonType !== 'Blank'"></ng-content>
</span>
